import { render, staticRenderFns } from "./CompositeSourceWizard.vue?vue&type=template&id=008df192&scoped=true"
import script from "./CompositeSourceWizard.vue?vue&type=script&lang=js"
export * from "./CompositeSourceWizard.vue?vue&type=script&lang=js"
import style0 from "./CompositeSourceWizard.vue?vue&type=style&index=0&id=008df192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008df192",
  null
  
)

export default component.exports